import React, { Component } from 'react'
import Modal from 'react-responsive-modal'
import PropTypes from 'prop-types'
import Inputbox from '../Inputbox'
import Calendar from 'react-calendar'
import { withAlert } from 'react-alert'
import moment from 'moment'
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap'

import './index.scss'
import { SITE_TXT, ALPHA_NUMERIC_PATTERN, EMAIL_PATTERN, EMAIL_PATTERN_DOMAIN } from '../../Utils/constants'
import { isValidPattern } from '../../Utils/functions'

class PublishLink extends Component {
    state = {
        open: true,
        validityDate: new Date(),
        userName: '',
        lopCreator: JSON.parse(localStorage.getItem('userInfo')).name,
        lopId: '',
        showCalendar: false,
        first_name: '',
        last_name: '',
        email: '',
    }
    resetModal = () => {
        this.setState(
            {
                open: false,
                showCalendar: false,
            },
            () => {
                this.props.onClose(false)
            }
        )
    }

    showCalendar = () => {
        const { showCalendar } = this.state
        this.setState({ showCalendar: !showCalendar })
    }

    handleDateChange = validityDate => this.setState({ validityDate, showCalendar: false })

    handleChange = (field, value) => {
        this.setState({
            [field]: value,
            showCalendar: false,
        })
    }

    createFormData = () => {
        const { first_name = '', last_name = '', email = '', validityDate = '' } = this.state

        const { id = '' } = this.props
        let data = new FormData()
        // data.append('userName', userName)
        data.append('first_name', first_name)
        data.append('last_name', last_name)
        data.append('email', email)
        data.append('userName', email)
        data.append('loginValidity', moment(validityDate).format('MM/DD/YYYY'))
        data.append('myLopId', id)

        return data
    }

    isFormValid = () => {
        const { alert } = this.props
        const { error } = alert
        const { first_name, last_name, email } = this.state
        if (isValidPattern(first_name, ALPHA_NUMERIC_PATTERN)) {
            error(SITE_TXT.TXT_NAME_VALID_PATTERN)
            return false
        }
        if (isValidPattern(last_name, ALPHA_NUMERIC_PATTERN)) {
            error(SITE_TXT.TXT_NAME_VALID_PATTERN)
            return false
        }
        if (!isValidPattern(email, EMAIL_PATTERN) || email.split('@')?.[1]?.includes('mckinsey') || false) {
            error(SITE_TXT.TXT_EMAIL_INVALID)
            return false
        }
        return true
    }

    handlePublishLink = e => {
        e.preventDefault()

        if (!this.isFormValid()) {
            return
        }
        const validData = this.createFormData()
        const { addExternalUser } = this.props

        addExternalUser(validData)
    }

    render() {
        const styleClasses = {
            modal: 'PublishLinkModal',
            overlay: 'overlayPublishLinkModal',
            closeButton: 'close-btn-modal',
        }
        const { showCalendar, userName, lopCreator, validityDate, first_name, last_name, email } = this.state
        return (
            <Modal open onClose={() => this.resetModal()} center classNames={styleClasses}>
                <div className="header">Publish LOP Link</div>

                {/* <Inputbox
                    placeholder={'Please enter the Client User Group'}
                    type="text"
                    label={'Please indicated desired login name for external viewer (e.g., ClientCoViewer).'}
                    fieldFor={'userName'}
                    onChange={this.handleChange}
                    value={userName}
                    max={15}
                /> */}

                <Inputbox
                    placeholder={'Please enter the first name'}
                    type="text"
                    label={'Please indicate the first name of the external viewer.'}
                    fieldFor={'first_name'}
                    onChange={this.handleChange}
                    value={first_name}
                    max={15}
                />
                <Inputbox
                    placeholder={'Please enter the last name'}
                    type="text"
                    label={'Please indicate the last name of the external viewer.'}
                    fieldFor={'last_name'}
                    onChange={this.handleChange}
                    value={last_name}
                    max={15}
                />
                <Inputbox
                    placeholder={'Please enter the email'}
                    type="email"
                    label={'Please indicate the email of the external viewer.'}
                    fieldFor={'email'}
                    onChange={this.handleChange}
                    value={email}
                />

                {/* <Inputbox
                    type="text"
                    label={
                        'Please indicate your email address. You will receive a message indicating the URL, username, and auto-generated password to share with your client.'
                    }
                    fieldFor={'lopCreator'}
                    readonly={true}
                    onChange={this.handleChange}
                    value={lopCreator}
                    placeholder={'Please enter the LOP Creator Name'}
                /> */}

                <div className="calendar-container form-group">
                    <label>Please indicate date on which external viewer access should expire.</label>
                    <Dropdown isOpen={showCalendar} toggle={this.showCalendar}>
                        <DropdownToggle>
                            {moment(validityDate).format('MM/DD/YYYY')}
                            <img src={SITE_TXT.CALENDAR_IMG} alt="" />
                        </DropdownToggle>
                        <DropdownMenu>
                            <Calendar
                                onChange={this.handleDateChange}
                                value={new Date(validityDate)}
                                minDate={moment().toDate()}
                            />
                        </DropdownMenu>
                    </Dropdown>
                </div>

                <div className={'buttonContainer btn'}>
                    <button
                        disabled={first_name === '' || last_name === '' || email === ''}
                        className="btn btn-primary"
                        onClick={e => this.handlePublishLink(e)}
                    >
                        {SITE_TXT.TXT_DONE}
                    </button>

                    <button className="cancelContent" onClick={e => this.resetModal()}>
                        {SITE_TXT.TXT_CANCEL}
                    </button>
                </div>
            </Modal>
        )
    }
}

PublishLink.propTypes = {
    onCloseModal: PropTypes.func,
}

export default withAlert(PublishLink)
